/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Delete_Button_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete standards preset" |
*
* @param {Standards_Preset_Delete_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_delete_button_aria_label = /** @type {((inputs?: Standards_Preset_Delete_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Delete_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "es") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Delete standards preset")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Delete standards preset")
	return /** @type {LocalizedString} */ ("Delete standards preset")
});